// Module
var code = "<div class=\"rate-components\"> <div class=\"current-rate\">1.0x</div> <ul class=\"rate-list\"> <li data-rate=\"0.75\">0.75x</li> <li data-rate=\"1.0\" class=\"current\">1.0x</li> <li data-rate=\"1.25\">1.25x</li> <li data-rate=\"1.5\">1.5x</li> <li data-rate=\"2.0\">2.0x</li> <li data-rate=\"2.5\">2.5x</li> </ul> </div> ";
// Exports
module.exports = code;